module.exports = __webpack_public_path__ + "static/media/DF-fund-logo.0fcbe060.png";